import { render, staticRenderFns } from "./wegymer-consult-us.vue?vue&type=template&id=13536aae&scoped=true&"
import script from "./wegymer-consult-us.vue?vue&type=script&lang=js&"
export * from "./wegymer-consult-us.vue?vue&type=script&lang=js&"
import style0 from "./wegymer-consult-us.vue?vue&type=style&index=0&id=13536aae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13536aae",
  null
  
)

export default component.exports